export default "__VITE_ASSET__yRCtbB6r__"